/* eslint-disable */
export default {
  // actions
  actions: {
    addDamage: 'Añadir daño',
    login: 'Login',
    select: 'Seleccionar',
    clear: 'Limpiar',
    continue: 'Continuar',
    cancel: 'Cancelar',
    import: 'Importar',
    export: 'Exportar',
    exportAll: 'Exportar todos',
    selectFile: 'Seleccionar fichero',
    search: 'Buscar',
    save: 'Guardar',
    delete: 'Eliminar'
  },
  downloadModal: {
    title: 'Descargando archivo',
    text:
      'El archivo puede tardar varios minutos en descargarse, no abandone la página.'
  },
  // component: furniture
  furniture: {
    title: 'Mobiliario',
    empty: {
      short: 'Falta referencia de siniestro',
      long:
        'Para poder añadir daños de mobiliario, introduzca referencia del siniestro y la dirección.'
    },
    kindOfProperty: 'Tipo de propiedad',
    kindOfPropertyOptions: {
      owner: 'Propietario',
      renter: 'Inquilino'
    }
  },
  // component: warrantyLayout
  warrantyLayout: {
    registerSinister: 'Registrar siniestro',
    newSinister: 'Nuevo siniestro',
    registeredDamages:
      '0 x Daños registrados | 1 x Daño registrado | {count} x Daños registrados',
    modals: {
      newSinister: {
        title: 'Nuevo siniestro. ¿Estás seguro?',
        body: 'Se restaurarán todos los datos de los formularios.'
      }
    }
  },
  // component: warrantyRef
  warrantyRef: {
    sinisterRef: {
      literal: 'Referencia del siniestro'
    },
    secondaryRef: {
      literal: 'Referencia secundaria (opcional)'
    }
  },
  damageTypeCpi: {
    calendarLabel: {
      literal: 'Fecha de compra'
    },
    priceDamage: {
      literal: 'Precio de compra'
    }
  },
  // component: warrantyProps
  warrantyProps: {
    aboutProperty: 'Información de la propiedad',
    address: {
      literal: 'Dirección',
      placeholder: 'Introduce una ubicación'
    },
    zipCode: {
      literal: 'Código postal'
    },
    propertyType: {
      literal: 'Tipo de propiedad',
      options: {
        appartment: 'Apartamento',
        maison: 'Casa',
        local_commercial: 'Local comercial'
      }
    },
    residentType: {
      literal: 'Tipo de residente',
      options: {
        propietarie: 'Propietario',
        locataire: 'Inquilino',
        propietarie_non_occupant: 'Arrendatario'
      }
    },
    moreThanTwoYears: {
      literal: 'Edad del inmueble',
      options: {
        more: 'Más de 2 años',
        less: 'Menos de 2 años'
      }
    },
    map: {
      empty: {
        title: 'No hay ubicación',
        text: 'Introduce una ubicación válida'
      }
    },
    nameApplicant: {
      literal: 'Nombre del asegurado',
      placeholder: 'Introduce el nombre'
    },
    formsList: 'Formularios',
    fnolIdsList: 'Contrato',
    userIdsList: 'Tipo de usuario',
    buttonLink: {
      literal: 'Ver enlace de usuario'
    },
    modalLink: {
      buttonGenerateLink: 'Generar un enlace',
      buttonCancel: 'Anular',
      title: 'Vínculo con el usuario',
      alertMessage: 'Se debe completar la información complementaria.',
      alertAction: 'Completar la información complementaria'
    },
    moreInfoModal: {
      buttonGenerateLink: 'Información adicional',
      buttonCancel: 'Cancelar',
      title: 'Información adicional',
      send: 'Enviar',
      personalInfo: {
        title: '1. Datos personales',
        name: 'Nombre',
        surname: 'Apellidos',
        phone: 'Teléfono',
        city: 'Ciudad'
      },
      contractInfo: {
        title: '2. Contrato',
        isValid: '¿Es válido el contrato?',
        deductibles: 'Real estate deductible (€)',
        allowance: 'Indemnización por adornos (€)',
        furnitureAllowance: 'Dotación para mobiliario (€)',
        swimmingPool: 'Opción(es) contratada(s) - Piscina',
        externalFittings: 'Opción(es) suscrita(s) - Accesorios exteriores'
      },
      verifications: {
        title: '3. Comprobaciones',
        beforeSinister:
          'Ningún siniestro actual en la misma dirección y con la misma cobertura que se haya producido en los 15 días anteriores o posteriores a este siniestro.',
        GaG: 'Nombre de Gré à gré',
        ren: 'Nombre de Ren',
        cause: '¿Cuál fue la causa del siniestro?'
      },
      modalInformation: {
        title: 'Información faltante',
        literal: 'Para crear un enlace, primero debe completar la información adicional.',
        literal2: 'Por favor, complete esta sección antes de continuar.',
        cancel: 'Cancelar',
        completeInformation: 'Completar la información',
      }
    },
    optionsUserType: {
      insured: 'Selfcare genérico',
      professional: 'Selfcare BillMA profesional',
      billma_insured: 'Selfcare BillMA Asegurado',
      billma_agent: 'Selfcare Agente',
      billma_user: 'Selfcare BillMA',
      ren_professional: 'Selfcare Ren profesional',
      ren_insured: 'Selfcare Ren Asegurado'
    },
    clientPhoneNumber: 'Número de teléfono',
    clientEmail: 'Email',
    clientValidationType: 'Tipo de validación',
    countryCode: 'Prefijo',
    example: 'Ejemplo: ',
    requiredFields: {
      title: 'Campos obligatorios',
      body: 'Campos obligatorios no completados'
    }
  },
  // component: warrantySticky
  warrantySticky: {
    analyze: 'Analizar',
    generateReport: 'Generar reporte',
    generateReportFnol: 'Descripción daños',
    materialListBtn: 'Lista de material',
    smartReport: 'Informe Smart',
    damageSummary: {
      title: 'Valoración de daños',
      tableHead: {
        damages: 'Daños',
        greAGre: 'Hágalo usted mismo',
        reparationNetwork: 'Reparación red interna',
        reparationExcept: 'Reparación red externa'
      },
      tableSubHead: {
        embellishments: 'Adornos',
        immobilier: 'Continente',
        mobilier: 'Contenido'
      },
      tableMain: {
        manpowerHours: 'MO (horas)',
        manpowerCost: 'MO (euros)',
        materialCost: 'Material',
        totalCost: 'Total',
        priceWithoutTaxes: 'Sin IVA',
        priceWithTaxes: 'Con IVA'
      },
      description: {
        quantity: 'Cantidad'
      }
    },
    damageCounters: {
      gag: 'Hágalo usted mismo',
      materials: 'Materiales y herramientas',
      estimatedTime: 'Tiempo estimado',
      authorizedNetworkRepair: 'Reparación red interna',
      artessianRepair: 'Reparación red externa',
      immediate: 'Inmediato',
      difference: 'Diferido',
      ensembleImage: 'Foto general',
      presImage: 'Foto de cerca',
      totalPrice: 'Precio total'
    },
    manPower: {
      title: 'Cambio de precio de mano de obra',
      calculatePrice: 'Calcular precio',
      cancel: 'Cancelar',
      setPrice: 'Fijar precio'
    },
    materialList: {
      title: 'Materiales y mano de obra',
      manpowerTime: 'Mano de obra (h)',
      manpowerPrice: 'Mano de obra (€)',
      manpowerTitle: 'Precio de mano de obra',
      materials: 'Materiales',
      gag: 'Indemnización "Hágalo usted mismo"',
      downloadPDF: 'Descargar PDF',
      cancel: 'Cancelar',
      send: 'Enviar'
    }
  },
  // component: login
  login: {
    title: 'Mes dommages',
    titleMA: 'MAValue',
    text: 'Comience a registrar sus siniestros',
    authenticationError: 'Error en la autenticación',
    authenticationBlock: 'Login bloqueado, intentelo pasado unos minutos',
    authenticationOk: 'Login realizado correctamente',    
    sso_processing: 'Verificando identidad...',
    sso_wait: 'Por favor, espere un momento.',
    sso_error_title: 'Error de autenticación',
    sso_error_msg: 'Ha ocurrido un error durante el inicio de sesión mediante SSO. Por favor, inténtelo de nuevo o póngase en contacto con su administrador.',
    inputs: {
      username: 'Nombre de usuario',
      password: 'Contraseña'
    },
    login: 'Login'
  },
  // component: error
  error: {
    title: 'Mes Dommages',
    titleMA: 'MAValue',
    text: 'La página que estás buscando no existe.',
    btn: 'Volver'
  },
  // component: adminLayout
  adminLayout: {
    modals: {
      import: {
        title: 'Importar parámetros',
        description:
          'Para añadir o modificar parámetros de daños importe un fichero. Si el parámetro no existe, se creará. En caso de que el parámetro ya exista, se sobreescribirán sus datos.'
      },
      export: {
        title: 'Exportar parámetros',
        description:
          'Seleccione los grupos de garantía por los que desea filtrar.'
      }
    },
    filters: {
      warranty: 'Grupo de garantía',
      subwarranty: 'Sub grupo de garantía'
    },
    notifications: {
      importedFile: {
        title: 'Fichero importado',
        body: 'La tabla será recargada'
      }
    }
  },
  // component: parameters (gagadmin)
  gagParameters: {
    title: 'Parámetros',
    table: {
      paramName: 'Nombre del parámetro',
      paramValue: 'Valor del parámetro',
      customizable: 'Editable'
    }
  },
  // component: repMat (gagadmin)
  gagRepMat: {
    title: 'Materiales de reparación',
    table: {
      rep_type_code: 'Código',
      rep_description: 'Descripción',
      rep_mat: 'Material',
      mat_format_sale: 'Formato de venta',
      dam_measure_unit: 'Unidad de medida',
      conv_unit_per_mat_measure: 'Unidad de conversión por medida de material',
      mat_unit_price: 'Precio',
      is_hours: 'Sólo horas',
      image: 'Imagen'
    }
  },
  // component: zipCode (gagadmin)
  gagZipCode: {
    title: 'Códigos postales',
    table: {
      dept_code: 'Código de departamento',
      zip_code_min: 'Código postal mínimo',
      zip_code_max: 'Código postal máximo',
      country: 'País',
      clean_cost: 'Coste',
      displacement_hours: 'Horas de desplazamiento',
      coef: 'Coeficiente',
      factmin: 'Facturación mínima'
    }
  },
  // component: ajustage (gagadmin)
  gagAjustage: {
    title: 'Ajustar por edad del cliente',
    table: {
      interval_age_start: 'Edad mínima',
      interval_age_end: 'Edad máxima',
      age_coef: 'Coeficiente'
    }
  },
  // component: userLimits (gagadmin)
  gagUserLimits: {
    title: 'Límites',
    table: {
      user: 'Usuario',
      hour_price_max_limit: 'Precio/hora max.',
      hour_price_min_limit: 'Precio/hora min.'
    }
  },
  // component: salaries (gagadmin)
  gagSalaries: {
    title: 'Salarios',
    table: {
      zip_code: 'Código postal',
      csp: 'Profesión',
      salary_hour: 'Precio/hora'
    }
  },
  // component: parameters (admin)
  parameters: {
    title: 'Parámetros',
    table: {
      paramName: 'Nombre del parámetro',
      paramValue: 'Valor del parámetro',
      customizable: 'Editable',
      type: 'Tipo'
    }
  },
  // component: reparations (admin)
  reparations: {
    title: 'Reparaciones',
    warrantyid: 'Grupo de garantía',
    subcategory: 'Subcategoría',
    table: {
      repTypeCode: 'Código de reparación',
      description: 'Descripción',
      type: 'Tipo de reparación',
      surfaceUnit: 'Unidad de medida',
      damagesType: 'Tipo de daño',
      priceCalcForm: 'Precio cálculo formulario'
    }
  },
  // component: coefficients (admin)
  coefficients: {
    title: 'Coeficientes',
    table: {
      repCodeType: 'Código de reparación',
      description: 'Descripción',
      matSRen: 'Mat_s_REN',
      coefMat: 'Coef_mat',
      coefMo: 'Coef_mo',
      price: 'Precio'
    }
  },
  // component: depreciations (admin)
  depreciations: {
    title: 'Depreciaciones',
    table: {
      repTypeCode: 'Código de reparación',
      description: 'Descripción',
      years: 'Años',
      depreciationPerc: 'Porcentaje de reparación'
    }
  },
  // component: transversalCosts
  transversalcosts: {
    title: 'Costes transversales',
    table: {
      damageType: 'Tipo de daño',
      componentName: 'Nombre del componente',
      description: 'Descripción',
      costFormat: 'Coste del formato',
      value: 'Valor'
    }
  },
  // component: users
  users: {
    title: 'Usuarios',
    newUser: 'Nuevo usuario',
    table: {
      username: 'Nombre de usuario',
      firstName: 'Nombre',
      lastName: 'Apellidos',
      email: 'E-mail',
      role: 'Rol',
      company: 'Empresa'
    },
    modals: {
      newUser: {
        title: 'Nuevo usuario'
      },
      editUser: {
        title: 'Editar usuario'
      },
      deleteUser: {
        title: 'Vas a borrar este usuario.',
        body: 'Está acción es irreversible. ¿Desea continuar?'
      },
      user: {
        fields: {
          firstName: 'Nombre',
          lastName: 'Apellidos',
          username: 'Nombre de usuario',
          email: 'Email',
          company: 'Nombre de empresa',
          role: 'Rol de usuario',
          password: 'Contraseña',
          repeatPassword: 'Repetir contraseña'
        }
      }
    },
    filters: {
      company: 'Filtrar por compañía',
      role: 'Filtrar por rol'
    }
  },
  // component: forms
  adminForms: {
    filterLabel: 'Filtrar por formulario',
    import: {
      title: 'Importar ajustes',
      description:
        'Para agregar o modificar parámetros, importe un archivo. Si el parámetro no existe, se creará o modificará de otro modo.'
    },
    export: {
      title: 'Exportar configuraciones',
      description:
        'Para agregar o modificar parámetros, exporte un archivo y luego vuelva a importarlo.'
    },
    toast: {
      success: 'El archivo se procesó correctamente',
      error: 'No se pudo procesar el archivo'
    },
    modal: {
      title: 'Documento en tramitación',
      description:
        'Este proceso puede tardar unos minutos. No cierre la aplicación'
    }
  },
  // component: small device modal
  smDevModal: {
    title: 'Resolución de pantalla no válida',
    text:
      'El contenido que desea ver no está disponible para la resolución de su pantalla. Por favor, vuelva intentarlo desde un dispositivo con una resolución mayor de 1024px'
  },
  // notification
  notifications: {
    error: {
      0: {
        title: 'Error',
        body: 'Ha ocurrido un error al realizar la acción'
      },
      400: {
        title: 'Faltan campos',
        body: 'Revise los campos del formulario'
      },
      500: {
        title: 'Error',
        body: 'Ha ocurrido un error'
      },
      409: {
        title: 'Error de identificador',
        body: 'El siniestro ya existe'
      },
      title: 'Error',
      body: 'Ha ocurrido un error al realizar la acción'
    },
    addDamage: {
      title: 'Daño creado',
      body: 'El daño se ha creado correctamente'
    },
    newSinister: {
      title: 'Nuevo siniestro',
      body: 'Ha cambiado la identificación del siniestro'
    },
    deleteDamage: {
      title: 'Daño eliminado',
      body: 'El daño se ha eliminado correctamente'
    },
    pdfDamages: {
      title: 'Reporte creado',
      body: 'El reporte se ha generado correctamente'
    },
    pdfMaterial: {
      title: 'Reporte creado',
      body: 'El reporte se ha generado correctamente'
    },
    mailPdfMaterial: {
      title: 'Email enviado',
      body: 'El email se ha enviado correctamente',
      error: {
        title: 'Email no válido',
        body: 'Introduce un email correcto'
      }
    },
    moCalculation: {
      title: 'Precio actualizado',
      body: 'Recargando reporte'
    },
    changeLanguage: {
      title: 'Cambio de idioma',
      body: 'Redirigiendo'
    },
    loadSinisterOK: {
      title: 'Siniestro cargado',
      body: 'Actualizando información'
    },
    loadSinisterKO: {
      title: 'Error de siniestro',
      body: 'Error al cargar el siniestro'
    },
    paramChanged: {
      title: 'Parámetro cambiado',
      body: 'La tabla se actualizará automáticamente'
    },
    user: {
      isRequired: {
        title: 'Faltan campos',
        body: 'Por favor, complete correctamente todos los campos'
      },
      isEmail: {
        title: 'Email erróneo',
        body: 'El email introducido no es válido'
      },
      isSamePassword: {
        title: 'Repite contraseña',
        body: 'Las contraseñas no coinciden'
      },
      createdUser: {
        title: 'Usuario creado',
        body: 'Actualizando vista'
      },
      modifiedUser: {
        title: 'Usuario modificado',
        body: 'Actualizando vista'
      },
      deletedUser: {
        title: 'Usuario eliminado',
        body: 'Actualizando vista'
      },
      error: {
        400: {
          title: 'Faltan campos',
          body: 'Revise los campos del formulario'
        },
        500: {
          title: 'Error',
          body: 'Ha ocurrido un error'
        },
        409: {
          title: 'Error de identificador',
          body: 'El usuario ya existe'
        }
      }
    }
  },

  // charts view
  charts: {
    mapTitle: ' Geolocalizacion de siniestros',
    sinisterEvolutionTitle: 'Evolutivo de siniestros',
    tableTitle: 'Tabla de datos',
    noDataAvailable: 'No hay datos disponibles',
    barChartDamageSubType: 'Coste medio del tipo de garantía',
    barChartDamageType: 'Coste medio del tipo de daño',
    barChartCompensationType: 'Coste por tipo de indemnización',
    pieChart: 'Distribución por subtipo de daño',
    titleView: 'Dashboard',
    downloadData: 'Descargar datos',
    fromDate: 'De',
    toDate: 'A',
    hintToDate: "Por favor seleccione también 'hasta la fecha '",
    hintFromDate: "Por favor seleccione también 'a partir de la fecha'",
    tableHeadTitle: {
      company: 'Empresa',
      userName: 'Nombre de usuario',
      l1: 'Nivel 1',
      l2: 'Nivel 2',
      l3: 'Nivel 3',
      l4: 'Nivel 4',
      q: 'q',
      averageCost: 'Costo promedio',
      total: 'Total'
    },
    bubbleChartLegend: {
      price: 'Importe',
      damagesCount: 'Frecuencia'
    }
  },

  // search view
  search: {
    secondaryRef: 'Referencia secundaria',
    status: 'Estado',
    gag: 'HTM',
    ren: 'Red int.',
    asp: 'Red ext.',
    createdDate: 'Fecha de creación',
    updatedDate: 'Fecha de actualización'
  },

  // tutorials view
  tutorials: {
    title: 'Tutoriales',
    subtitle: 'Tutorial'
  },

  // Biens obiliers View
  biensMobiliers: {
    title: 'Bienes mobiliarios',
    searchEmpty: {
      search: 'Su búsqueda',
      notFound: 'no obtuvo resultados'
    },
    text:
      'Usa el buscador o navega por el menú lateral para encontrar el artículo que buscas. También puedes seleccionar entre nuestras categorías más frecuentes'
  },

  // dashboard view
  dashboard: {
    GAG: {
      title: 'Gag y televaluaciones',
      downloadData: 'Descargar datos',
      filters: {
        date: 'Periodo',
        startDate: 'Fecha de inicio',
        endDate: 'Fecha de fin',
        orderBy: 'Ordenar por',
        orderByOptions: {
          tmo: 'TMO',
          totalGAG: 'Total GAG',
          sinisterTotal: 'Total televal',
          conversion: 'Conversión'
        }
      },
      kpis: {
        gag: 'GAG realizados',
        TE: 'Televaluaciones efectuadas',
        gagWeek: 'Gest con 1 GAG/sem',
        gagSans: 'Gest sin GAG'
      },
      table: {
        headers: {
          manager: 'Administradora',
          conversion: 'Conversión',
          weeks: 'Semanas',
          evolution: 'Evolución',
          total: 'Total',
          totalGAG: 'Total GAG',
          totalTE: 'Total televal',
          TMO: 'TMO'
        }
      }
    }
  },

  // common
  common: {
    surface: 'Superficie',
    line: 'Línea',
    distance: 'Distancia',
    actualCalc: 'Cálculo actual',
    selectOnTheMap: 'Seleccione sobre el mapa para medir',
    mapAction: 'Medir en el mapa',
    mapActionLine: 'Mide el mapa',
    min: 'Mínimo',
    max: 'Máximo',
    total: 'Total',
    recommended: 'Recomendado',
    standard: 'Estándar',
    noFile: 'Ningún fichero seleccionado',
    email: 'Correo electrónico',
    search: 'Búsqueda',
    results: 'Resultados',
    noresults: {
      short: 'No hay resultados',
      long: 'No se encontraron resultados para tu búsqueda'
    },
    true: 'Sí',
    false: 'No',
    noOptions: 'No hay opciones',
    noSelected: 'Ninguno seleccionado',
    agentView: 'Vista agente',
    managerView: 'Vista tramitador',
    unit: '0 unidades | x {count} unidad | x {count} unidades'
  },
  empties: {
    noResults: {
      title: 'No hay resultados',
      descr: 'Utilice otros parámetros de búsqueda'
    }
  },
  // Area component
  areaMeasurement: {
    damageArea: 'Área dañada',
    measurementTipe: 'En metros cuadrados',
    heightMeasurement: 'Altura',
    widhtMeasurement: 'Anchura'
  }
}
